import { VOUCHER_LENGTH_TYPES } from '../../app/core/constants'

/**
 * AddVoucherBatchCtrl controller
 * Add vouchers
 */

/**
 * AddVoucherBatchCtrl controller
 *
 * @class AddVoucherBatchCtrl
 * @memberof mwApp/partners
 * @see mwApp/partners
 *
 * @ngdoc controller
 * @name mwApp/partners.controller:AddVoucherBatchCtrl
 */
/* @ngInject */
export default function AddVoucherBatchCtrl ($scope, $uibModalInstance, VoucherBatch, distributor) {
  var vm = this
  vm.rentLengthTypes = VOUCHER_LENGTH_TYPES

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Distributor
   *
   * @memberof mwApp/partners.controller:AddVoucherBatchCtrl
   * @type {models.Distributor}
   */
  vm.distributor = distributor

  /**
   * New VoucherBatch
   *
   * @memberof mwApp/partners.controller:AddVoucherBatchCtrl
   * @type {models.VoucherBatch}
   */
  var voucher = vm.voucher = new VoucherBatch({
    $distributor: distributor
  })

  /**
   * Load extra of batch.
   */
  VoucherBatch.loadExtra({ id: 0, $distributor: distributor })
    .to(vm.extraBatch = {})
    .then(() => { $scope.loading = false })

  /**
   * Add voucher to distributor
   *
   * @memberof mwApp/partners.controller:AddVoucherBatchCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    voucher._save()
      .then(
        () => $uibModalInstance.close(voucher)
      )
      .finally(vm.unsetDisable)
  }

  /**
   * Close modal window
   *
   * @memberof mwApp/partners.controller:AddVoucherBatchCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
